import OrtTypeIcon from "./OrtTypeIcon";

export default function OrtCheckbox({item, group, filters, setFilters}) {
    const checked = filters[group].includes(item);
    let newValues;
    if (!checked) {
        newValues = [...filters[group], item];
    }
    else {
        newValues = filters[group].filter(value => value !== item);
    }

    return <label className="ort-form__checkbox">
        <input className="ort-form__checkbox-input"
               type="checkbox" name={item} checked={checked} onChange={() => setFilters({...filters, [group]: newValues})}/>
        <span className="ort-form__box" aria-hidden="true" />
        <span className="ort-form__checkbox-label">{item}</span>
        <OrtTypeIcon ortType={item} />
    </label>
}
